export const buildNumber = '20260420.2';
export const version = '3.13.0';
export const latestCommit = '1577e7919fd3619ff32401bf063957545a1b4713';
